import { motion } from 'framer-motion';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/f7081275c8c5ad77b7068ab2b9330b46/528b3264b18c56da3a6c4c73d7ce5afc.jpeg"
          alt="Campo Esportivo Premium"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B4D3E]/50 via-[#1B4D3E]/40 to-[#1B4D3E]/50" />
      </div>

      {/* Desktop: Feature cards on the right */}
      <div className="hidden lg:flex absolute right-0 top-0 bottom-0 w-[40%]">
        <div className="relative h-full flex flex-col justify-center items-center gap-12 px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            className="bg-white/12 backdrop-blur-[10px] rounded-2xl p-8 w-full max-w-[280px]"
          >
            <div className="w-12 h-12 flex items-center justify-center mb-4">
              <i className="ri-trophy-line text-[#C5A059] text-3xl"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-2">Qualidade FIFA</h3>
            <p className="font-montserrat text-white/70 text-sm">Certificação internacional para campos esportivos</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.6 }}
            className="bg-white/12 backdrop-blur-[10px] rounded-2xl p-8 w-full max-w-[280px]"
          >
            <div className="w-12 h-12 flex items-center justify-center mb-4">
              <i className="ri-flag-line text-[#C5A059] text-3xl"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-2"><span translate="no" className="notranslate">Tecnologia Limonta</span></h3>
            <p className="font-montserrat text-white/70 text-sm">Engenharia italiana de classe mundial</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.6 }}
            className="bg-white/12 backdrop-blur-[10px] rounded-2xl p-8 w-full max-w-[280px]"
          >
            <div className="w-12 h-12 flex items-center justify-center mb-4">
              <i className="ri-award-line text-[#C5A059] text-3xl"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-2">Garantia Técnica</h3>
            <p className="font-montserrat text-white/70 text-sm">Excelência em cada projeto executado</p>
          </motion.div>
        </div>
      </div>

      {/* Main content area */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-8 w-full lg:w-[60%] py-24 lg:py-0">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center lg:items-start"
        >
          <div className="inline-flex items-center gap-2 bg-[#C5A059]/20 backdrop-blur-sm px-5 py-2 rounded-full mb-6">
            <span className="font-montserrat text-white text-xs uppercase tracking-wider">Representante Oficial</span>
          </div>

          <h1 className="font-cinzel font-semibold text-white text-[28px] lg:text-[68px] leading-[1.2] tracking-wide mb-6 max-w-[600px] text-center lg:text-left">
            Engenharia Italiana e Paisagismo de Alto Padrão
          </h1>

          <p className="font-montserrat font-light text-white/85 text-base lg:text-lg mb-10 max-w-[500px] text-center lg:text-left">
            <span translate="no" className="notranslate">Tecnologia Limonta Sport - Qualidade FIFA</span>
          </p>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            onClick={scrollToContact}
            className="group relative bg-[#C5A059] text-white font-montserrat font-semibold text-sm uppercase tracking-wide px-12 py-4 rounded-full overflow-hidden transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">Solicitar Visita Técnica</span>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-white text-lg"></i>
            </div>
          </motion.button>
        </motion.div>

        {/* Mobile: Feature cards stacked vertically */}
        <div className="flex lg:hidden flex-col items-center gap-[15px] mt-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            className="relative rounded-lg w-full max-w-[320px] overflow-hidden"
            style={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,20,0,0.5))'
            }}
          >
            <div 
              className="absolute left-0 top-0 bottom-0 w-1"
              style={{
                background: 'linear-gradient(to bottom, #C5A059, #8A6E2F)'
              }}
            />
            <div className="p-5 pl-5">
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className="ri-trophy-line text-[#C5A059] text-2xl"></i>
              </div>
              <h3 className="font-montserrat font-semibold text-white text-base mb-1 text-left">Qualidade FIFA</h3>
              <p className="font-montserrat text-white/75 text-sm text-left">Certificação internacional para campos esportivos</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1, duration: 0.6 }}
            className="relative rounded-lg w-full max-w-[320px] overflow-hidden"
            style={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,20,0,0.5))'
            }}
          >
            <div 
              className="absolute left-0 top-0 bottom-0 w-1"
              style={{
                background: 'linear-gradient(to bottom, #C5A059, #8A6E2F)'
              }}
            />
            <div className="p-5 pl-5">
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className="ri-flag-line text-[#C5A059] text-2xl"></i>
              </div>
              <h3 className="font-montserrat font-semibold text-white text-base mb-1 text-left"><span translate="no" className="notranslate">Tecnologia Limonta</span></h3>
              <p className="font-montserrat text-white/75 text-sm text-left">Engenharia italiana de classe mundial</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.2, duration: 0.6 }}
            className="relative rounded-lg w-full max-w-[320px] overflow-hidden"
            style={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,20,0,0.5))'
            }}
          >
            <div 
              className="absolute left-0 top-0 bottom-0 w-1"
              style={{
                background: 'linear-gradient(to bottom, #C5A059, #8A6E2F)'
              }}
            />
            <div className="p-5 pl-5">
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className="ri-award-line text-[#C5A059] text-2xl"></i>
              </div>
              <h3 className="font-montserrat font-semibold text-white text-base mb-1 text-left">Garantia Técnica</h3>
              <p className="font-montserrat text-white/75 text-sm text-left">Excelência em cada projeto executado</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
